import { render, staticRenderFns } from "./IndexView.vue?vue&type=template&id=9919ca18&scoped=true"
var script = {}
import style0 from "./IndexView.vue?vue&type=style&index=0&id=9919ca18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9919ca18",
  null
  
)

export default component.exports